
import { Component, Vue, Ref } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { iArray } from '@/common/utils'
import CreateDetailLayout from '@/layout/edit_layout.vue'
import RowWrap from '@/components/detail/row_wrap/index.vue'
// eslint-disable-next-line
import AvatarUpload, { AvatarUploadIns } from '@/components/avatar_upload/index.vue'
import CreatePersonForm from './components/create_person_form.vue'
// eslint-disable-next-line
import DynamaicTags, { ins } from '@/components/dynamic_tags/index.vue'
import UploadImg from '@/common/class/UploadImg'
import { PersonService } from '@/services'

@Component({
    name: 'create-person',
    components: {
        CreateDetailLayout,
        RowWrap,
        AvatarUpload,
        CreatePersonForm,
        DynamaicTags
    }
})
export default class extends Vue {
    @Ref('formRef') private formEl!: any
    @Ref('avatarRef') private avatarEl!: AvatarUploadIns
    @Ref('keywordRef') private keywordEl!: ins
    @Ref('stopwordRef') private stopwordEl!: ins
    @Ref('bkeywordRef') private bkeywordEl!: ins
    private createLoading = false
    private keywords = []
    private stopwords = []
    private bKeywords = []
    private link: any = []
    private mounted() {
        AppModule.getTypes()
    }

    // 新增自媒体链接
    private onAddUrl() {
        this.link.push({ key: +new Date, value: '' })
    }
    // 删除媒体链接
    private onDeleteUrl(url: any) {
        iArray.remove(url, this.link)
    }

    private onCreate() {
        this.formEl.validate(async (person: any) => {
            this.createLoading = true
            const keywords = this.keywordEl.getTags()
            const stopwords = this.stopwordEl.getTags()
            const bkeywords = this.bkeywordEl.getTags()
            const imgFile = this.avatarEl.getFile()
            let avatarResult: any
            // 上传图片
            if (imgFile) {
                avatarResult = await new UploadImg(imgFile).upload()
                if (avatarResult.error) {
                    this.$mwarning('图片上传失败')
                    avatarResult = ''
                } else {
                    avatarResult = avatarResult.key
                }
            }

            const params = {
                ...person,
                avatar: avatarResult,
                keywords: keywords.join(','),
                stopwords: stopwords.join(','),
                b_keywords: bkeywords.join(','),
                link: this.link.map((l: any) => l.value).join(',')
            }
            const result = await PersonService.createPerson(params)
            this.createLoading = false
            if (result.status === 200) {
                return this.$msuccess('创建成功')
            }
            this.$merror(result.message || '发生错误, 请稍后再试')
        })
    }
}
